export async function shareProduct({url,title}, platform = navigator) {
  if (platform.share) {
    try { await platform.share({url,title}); return 'shared'; }
    catch (error) { if (error.name === 'AbortError') return 'cancelled'; }
  }
  try { await platform.clipboard.writeText(url); return 'copied'; }
  catch { return 'manual'; }
}
class TbwlShare extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.querySelector('button').addEventListener('click', async () => {
      const outcome = await shareProduct(this.dataset);
      if (outcome === 'copied') this.querySelector('[role="status"]').textContent = this.dataset.copied;
      if (outcome === 'manual') {
        this.querySelector('label').hidden = false;
        const input = this.querySelector('input'); input.focus(); input.select();
      }
    });
  }
}
if (!customElements.get('tbwl-share')) customElements.define('tbwl-share', TbwlShare);
